import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../helpers/Notification';
import { ButtonFile, LoadingWidget } from '../../../../widgets';
import {
  getFileUrl,
  saveArchivosAction,
} from '../../../archivos/ArchivosAction';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveEntidadesAction } from '../../entidades/EntidadesAction';

const FormEntImagenes = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const activo = entidadesStore.activo;

  const [fileImgFondo, setFileImgFondo] = React.useState();
  const [fileImgLogo, setFileImgLogo] = React.useState();

  const [loadingSave, setLoadingSave] = React.useState(false);

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }

    setLoadingSave(true);

    let values = {
      nombre: activo.nombre,
      correo: activo.correo,
      isAbierto: activo.isAbierto,
      tipoEntidad: activo.tipoEntidad,
      telefono: activo.telefono.numero,
      idEstatus: activo.estatus.id,
    };

    if (fileImgFondo) {
      const resFondo = await saveArchivosAction(dispatch, {
        file: fileImgFondo,
        isPublic: 't',
        desc: 'Foto de fondo de la entidad',
      });
      await saveEntidadesAction(
        { dispatch, notify },
        activo.id,
        {
          ...values,
          idImgFondo: resFondo.id,
        },
        null,
        true,
      );
    }

    if (fileImgLogo) {
      const resLogo = await saveArchivosAction(dispatch, {
        file: fileImgLogo,
        isPublic: 't',
        desc: 'Logo de la entidad',
      });
      await saveEntidadesAction(
        dispatch,
        activo.id,
        {
          ...values,
          idImgLogo: resLogo.id,
        },
        null,
        true,
      );
    }

    setLoadingSave(false);
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        </Grid>

        <Grid item xs={12} md={8}>
          <ButtonFile
            id={'imgFondo'}
            onFile={(file) => setFileImgFondo(file)}
            file={fileImgFondo}
            text="Subir imagén de fondo"
            sxc={{ marginTop: '5px' }}
            size="90%"
            name={activo?.imgFondo?.nombre ?? 'Image de fondo'}
            onDelete={() => setFileImgFondo(null)}
            src={!fileImgFondo && getFileUrl(activo.imgFondo)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ButtonFile
            id={'imgLogo'}
            onFile={(file) => setFileImgLogo(file)}
            file={fileImgLogo}
            text="Subir Logotipo"
            sxc={{ marginTop: '5px' }}
            size="70%"
            name={activo?.imgLogo?.nombre ?? 'Imagen del logo'}
            onDelete={() => setFileImgLogo(null)}
            src={!fileImgLogo && getFileUrl(activo.imgLogo)}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            loading={loadingSave}
            click={_handleSubmit}
            save
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntImagenes;
